import { InputAdornment, TextField } from '@material-ui/core';
import { Search } from '@material-ui/icons';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { getType } from 'typesafe-actions';
import { CardList, CardListAction } from '../../../../common/components/cards';
import { Checkbox } from '../../../../common/components/fields';
import { rootSelector } from '../../../../common/selectors/selectors';
import { usersActions } from '../../users.actions';
import { UserDto } from '../../users.dtos';
import UserListItem from './userListItem';

const UserList = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  const systemUsers = rootSelector((state) => state.users.list);

  const [showInactive, setShowInactive] = useState<boolean>(false);
  const [users, setUsers] = useState<UserDto[]>([]);
  const [searchField, setSearchField] = React.useState<string>('');

  useEffect(() => {
    dispatch({ type: getType(usersActions.request) });
  }, [dispatch]);

  useEffect(() => {
    setUsers(systemUsers);
  }, [systemUsers]);

  const onAdd = () => {
    history.push('/users/create');
  };

  const onSearch = (searchQuery: string) => setSearchField(searchQuery);

  useEffect(() => {
    const filteredUsers = systemUsers.filter(
      (s) =>
        s.lastName.toLowerCase().includes(searchField.toLowerCase()) ||
        s.firstName.toLowerCase().includes(searchField.toLowerCase()) ||
        s.email.toLowerCase().includes(searchField.toLowerCase()) ||
        s.phoneNumber?.includes(searchField)
    );
    setUsers(filteredUsers);
  }, [searchField]);

  return (
    <CardList
      actions={[
        <CardListAction
          key='Add new user'
          onClick={onAdd}
          tooltip='Add new user'
        />,
      ]}
      cards={users
        .filter((u) => showInactive || u.isActive === true)
        .map((u, i) => (
          <UserListItem key={i} user={u} />
        ))}
      filters={[
        <TextField
          autoFocus
          value={searchField}
          placeholder='Search'
          onChange={(e) => {
            onSearch(e.target.value);
          }}
          fullWidth
          InputProps={{
            startAdornment: (
              <InputAdornment position='start'>
                <Search />
              </InputAdornment>
            ),
          }}
        />,
        <Checkbox
          key='Switch'
          color='primary'
          label='Include Inactive'
          onChange={() => setShowInactive(!showInactive)}
          checked={showInactive}
          value={showInactive}
        />,
      ]}
      onScroll={() => console.log('You scrolled')}
      title='Users'
    />
  );
};

export default UserList;
